import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const BusinessGlobalFill = ({ color, ...props }: IconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_206_35510)">
                <path d="M1.36719 8.66691H5.01852C5.1326 10.7781 5.80555 12.8212 6.96852 14.5869C5.51181 14.3581 4.17198 13.653 3.15853 12.5819C2.14508 11.5108 1.51513 10.134 1.36719 8.66691ZM1.36719 7.33357C1.51513 5.86644 2.14508 4.48969 3.15853 3.41858C4.17198 2.34747 5.51181 1.64239 6.96852 1.41357C5.80555 3.17931 5.1326 5.22234 5.01852 7.33357H1.36719ZM14.6339 7.33357H10.9825C10.8684 5.22234 10.1955 3.17931 9.03252 1.41357C10.4892 1.64239 11.8291 2.34747 12.8425 3.41858C13.856 4.48969 14.4859 5.86644 14.6339 7.33357ZM14.6339 8.66691C14.4859 10.134 13.856 11.5108 12.8425 12.5819C11.8291 13.653 10.4892 14.3581 9.03252 14.5869C10.1955 12.8212 10.8684 10.7781 10.9825 8.66691H14.6345H14.6339ZM6.35385 8.66691H9.64719C9.53746 10.4666 8.97072 12.2085 8.00052 13.7282C7.03032 12.2085 6.46358 10.4666 6.35385 8.66691ZM6.35385 7.33357C6.46358 5.53392 7.03032 3.79195 8.00052 2.27224C8.97072 3.79195 9.53746 5.53392 9.64719 7.33357H6.35385Z" fill={color || "#000"} />
            </g>
            <defs>
                <clipPath id="clip0_206_35510">
                    <rect width="16" height="16" fill={color || "#000"} />
                </clipPath>
            </defs>
        </svg>

    )
}

export default BusinessGlobalFill